import StoreDefault from '@/assets/food/icons/storeDefault.svg?react'

import style from './StoreCardGrubhub.module.scss'

interface ImageProps {
  image: string
}

const StoreImageDefault = () => (
  <div className={style.StoreImageDefaultContainer}>
    <StoreDefault />
  </div>
)

export default memo<ImageProps>(function StoreImageFallback({image}) {
  const [isError, setIsError] = useState(false)

  const isEmpty = image === ''

  const renderContent = () => {
    if (isError || isEmpty) {
      return <StoreImageDefault />
    }

    return (
      <img
        key={`store-logo-${image}`}
        src={image}
        alt=''
        className={style.StoreImage}
        loading='lazy'
        onError={() => {
          setIsError(true)
        }}
      />
    )
  }

  return <>{renderContent()}</>
})
